'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'microscope';
var width = 512;
var height = 512;
var aliases = [128300];
var unicode = 'f610';
var svgPathData = 'M488 464h-41.42C486.6 428.8 512 377.4 512 320c0-105.9-86.13-192-192-192v48c79.41 0 144 64.59 144 144s-64.59 144-144 144H24C10.75 464 0 474.7 0 488C0 501.3 10.75 512 24 512h464c13.25 0 24-10.75 24-24C512 474.7 501.3 464 488 464zM120 432h176c13.25 0 24-10.75 24-24c0-13.26-10.75-24-24-24h-176C106.7 384 96 394.7 96 408C96 421.3 106.7 432 120 432zM160 320h16v16C176 344.8 183.2 352 192 352h32c8.836 0 16-7.164 16-16V320H256c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32c0-17.67-14.33-32-32-32H192C174.3 0 160 14.33 160 32C142.3 32 128 46.33 128 64v224C128 305.7 142.3 320 160 320zM176 80h64v192h-64V80z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMicroscope = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;